import { render, staticRenderFns } from "./model3.vue?vue&type=template&id=4fe131d8&scoped=true"
import script from "./model3.vue?vue&type=script&lang=js"
export * from "./model3.vue?vue&type=script&lang=js"
import style0 from "./model3.vue?vue&type=style&index=0&id=4fe131d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fe131d8",
  null
  
)

export default component.exports